/*
    Úvodní layout administrace
*/
import React,{ Component } from 'react';
import Header from './Header';
import Notification from '../GlobalComponents/Notification';
import {Switch, Route } from 'react-router-dom';
import withAdminAuthentication from '../Modules/Auth/Components/WithAuthentication';

import AllCategories from '../Modules/Category/Components/AllCategories.js';
import AllVideos from '../Modules/Video/Components/AllVideos.js';
import AllServices from '../Modules/Service/Components/AllServices.js';
import AllArticles from '../Modules/Article/Components/AllArticles.js';
import AllMarketings from '../Modules/Marketing/Components/AllMarketings.js';
import Customer from '../Modules/Customer/Components/Customer';
import ChangePassword from '../Modules/Auth/Components/ChangePassword';
import Link from '../Modules/Content/Components/Link';
import Invoice from '../Modules/Invoice/Components/Invoice';
import WebSettings from '../Modules/Settings/Components/Web';
import SengridSettings from '../Modules/Settings/Components/Sengrid';
import PayuSettings from '../Modules/Settings/Components/Payu';
import AllMemberships from '../Modules/Membership/Components/AllMemberships';


class Layout extends Component {
	
  render() {
	  	
    return (
	   
    	<div className="wholeContent">			       
 	      
 	        <div id="layout">	
				<Header />  
				<Switch>
        
					<Route exact path='/customer' component={Customer}></Route>
					<Route exact path='/content/link' component={Link}></Route>
					<Route exact path='/content/article' component={AllArticles}></Route>
					<Route exact path='/content/categories' component={AllCategories}></Route>
					<Route exact path='/content/videos' component={AllVideos}></Route>
					<Route exact path='/order/invoice' component={Invoice}></Route>
					<Route exact path='/content/services' component={AllServices}></Route>
					<Route exact path='/content/marketing' component={AllMarketings}></Route>
					<Route exact path='/content/membership' component={AllMemberships}></Route>
					<Route exact path='/settings/change-password' component={ChangePassword}></Route>
					<Route exact path='/settings/web' component={WebSettings}></Route>
					<Route exact path='/settings/sengrid' component={SengridSettings}></Route>
					<Route exact path='/settings/payu' component={PayuSettings}></Route>
					
				</Switch>
				<Notification />
			</div>
		     	       
		</div>
   
    );
  }
}

export default withAdminAuthentication(Layout);
